import React from 'react'
import COLORS from '../../styles/colors'
import { SVGProps } from '../../types/svg'

const defaultSize = {
  width: 63,
  height: 33,
}
function SvgComponent({ style, color = COLORS.brand.primaryDark }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 33 33'>
      <defs>
        <style>
          {`.prefix__c{fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}`}
        </style>
      </defs>
      <path className='prefix__c' d='M26.54 30.014V17.94a13.02 13.02 0 10-26.04 0v12.071' />
      <path
        className='prefix__c'
        d='M6.31 17.705H3.887a.522.522 0 00-.373.153.53.53 0 00-.157.371v.646c0 .554.665.554 1.248.645a37.8 37.8 0 00-.621 4.239v4.755a.941.941 0 00.946.936h1.444a.941.941 0 00.667-.272.94.94 0 00.279-.664v-1.34h12.416v1.34a.941.941 0 00.945.936h1.446a.941.941 0 00.945-.936v-4.755a37.6 37.6 0 00-.625-4.24c.578-.1 1.234-.08 1.234-.644v-.646a.528.528 0 00-.529-.523h-2.4'
      />
      <path
        className='prefix__c'
        d='M20.748 17.497c0 1.036-1.2 1.726-2.327 1.726H8.637c-1.129 0-2.327-.691-2.327-1.726l.933-3.311a2.075 2.075 0 012.051-1.779h8.478a2.06 2.06 0 012.047 1.779zM11.256 24.902h4.529M11.256 22.629h4.529M21.053 23.762a1.294 1.294 0 01-.383.911 1.292 1.292 0 01-.914.373 1.3 1.3 0 01-.5-.1 1.279 1.279 0 01-.42-2.1 1.317 1.317 0 011.408-.278 1.291 1.291 0 01.8 1.188zM8.598 23.762a1.3 1.3 0 01-1.792 1.188 1.286 1.286 0 01-.7-.694 1.278 1.278 0 01.282-1.4 1.292 1.292 0 01.914-.373 1.281 1.281 0 01.5.095 1.292 1.292 0 01.8 1.188zM12.363 14.142h2.336M23.077 27.173H3.984'
      />
    </svg>
  )
}

export default SvgComponent
